import { render, staticRenderFns } from "./carousel_Images.vue?vue&type=template&id=2f864930&scoped=true"
import script from "./carousel_Images.vue?vue&type=script&lang=js"
export * from "./carousel_Images.vue?vue&type=script&lang=js"
import style0 from "./carousel_Images.vue?vue&type=style&index=0&id=2f864930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f864930",
  null
  
)

export default component.exports